import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCopyRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.006 3.992a1 1 0 0 0-1 1v10.512a1 1 0 0 0 1 1h10.511a1 1 0 0 0 1-1V4.992a1 1 0 0 0-1-1H5.006Zm1 10.512V5.992h8.511v8.512H6.006ZM20.02 9.372a1 1 0 1 0-2 0v8.636H9.385a1 1 0 1 0 0 2h9.636a1 1 0 0 0 1-1V9.372Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCopyRoundLine);
export default Memo;
